import { compressToEncodedURIComponent as e, decompressFromEncodedURIComponent as t } from "lz-string";
//#region src/utils/url.ts
var n = !1;
function r() {
	if (window.top) try {
		return window.top.location.href, window.top;
	} catch {
		n ||= (console.debug("Error getting top location. Using window.location"), !0);
	}
	return window;
}
function i() {
	let { location: e, history: t } = r();
	return {
		location: e,
		history: t
	};
}
var a = (t, n, r = !0) => c({ [t]: r ? e(n) : n }, { replace: !0 }), o = (e, n = !0, r = !0, a) => {
	let { location: o } = i(), s;
	try {
		s = new URL(o.href).searchParams.get(e) || "";
	} catch (e) {
		return console.warn(`Error getting URL parameter: '${e.message}'. No data retrieved`), null;
	}
	let c = r ? t(s) : s;
	try {
		return !c || c === a ? null : n ? JSON.parse(c) : c;
	} catch (e) {
		return console.warn(`Error parsing URL parameter: '${e.message}'. No data retrieved`), null;
	}
}, s = () => {
	let { location: e } = i();
	try {
		return new URL(e.href).search;
	} catch (e) {
		return console.warn(`Error reading the current URL: '${e.message}'. No search retrieved`), "";
	}
}, c = (e, { replace: t = !1 } = {}) => {
	let { location: n, history: r } = i(), a = new URL(n.href);
	for (let [t, n] of Object.entries(e)) n === null ? a.searchParams.delete(t) : a.searchParams.set(t, n);
	if (a.href === n.href) return;
	let o = (e) => {
		try {
			return e ? r.replaceState(null, "", a.href) : r.pushState(null, "", a.href), !0;
		} catch {
			return !1;
		}
	};
	!o(t) && !t && !o(!0) && console.debug("The environment forbids history writes, the URL is left as it is");
}, l = (e) => c(Object.fromEntries(e.map((e) => [e, null])), { replace: !0 });
//#endregion
export { a as addParameterToUrl, e as compressToEncodedURIComponent, s as getCurrentSearch, o as getParameterFromUrl, r as getUrlWindow, l as removeParamsFromUrl, c as updateUrlParams };
